import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Cell, Grid, InputGroup, Row, H5, Subheading, DangerButton } from '@fs/zion-ui'
import { useParams } from '@fs/zion-router'
import { ContentDelete } from '@fs/zion-icon/dist/cjs/icons'
import JSONTable from '../../app/JSON'
import { getMessageById } from '../../../services/dmqueuesService'

export default function SimpleMessageDetailsView({ backToMessagesList, buttonTemplates }) {
  const { t } = useTranslation()
  const [message, setMessage] = useState(null)

  const pathParams = useParams()

  useEffect(() => {
    getMessageById(pathParams.messageId).then((theMessage) => {
      setMessage(theMessage.data)
    })
  }, [pathParams.messageId])

  if (!message) {
    return null
  }

  return (
    <Grid>
      {/* Row */}
      <Cell columns={12}>
        <H5 supplementary>
          <Row alignY="middle">
            <span>{message.queue}</span>
            <Button onClick={() => backToMessagesList()}>
              {t('queues.backToMessages', { defaultValue: `Back to ${message.queue}`, queue: message.queue })}
            </Button>
          </Row>
          <Subheading>{message.type}</Subheading>
        </H5>
      </Cell>
      {/* Row */}
      <Cell columns={12}>
        <Buttons message={message} backToMessagesList={backToMessagesList} buttonTemplates={buttonTemplates} />
      </Cell>
      {/* Row */}
      <Cell columns={12}>
        <JSONTable jsonContent={message} />
      </Cell>
    </Grid>
  )
}

function Buttons({ message, backToMessagesList, buttonTemplates }) {
  return (
    <InputGroup>
      <Row>
        {buttonTemplates.map((buttonTemplate) => (
          <React.Fragment key={buttonTemplate.buttonText}>
            {buttonTemplate.buttonText === 'Delete' ? (
              <DangerButton
                Icon={ContentDelete}
                onClick={() => buttonTemplate.buttonCallback({ message }).then(() => backToMessagesList())}
              >
                {buttonTemplate.buttonText}
              </DangerButton>
            ) : (
              <Button onClick={() => buttonTemplate.buttonCallback({ message }).then(() => backToMessagesList())}>
                {buttonTemplate.buttonText}
              </Button>
            )}
          </React.Fragment>
        ))}
      </Row>
    </InputGroup>
  )
}
